import Loadable, { defaultResolve } from '@/common/lazy/Loadable';
import imports from '@/routing/imports';
import RadarLoading from './views/RadarLoading';
import ScoreboardLoading from '@/matchtracker/views/ScoreboardLoading';

export const BetradarMTLoadable = Loadable({
    loader: {
        matchtracker: imports.matchtracker
    },
    loading: RadarLoading,
    exp: ({ matchtracker }) => {
        return defaultResolve(matchtracker).BetradarMT;
    }
});

export const BetradarMTScoreboardLoadable = Loadable({
    loader: {
        matchtracker: imports.matchtracker
    },
    loading: ScoreboardLoading,
    exp: ({ matchtracker }) => {
        return defaultResolve(matchtracker).BetradarMTScoreboardView;
    }
});
